import type { GenerationRequestSummaryRead, PostType } from '../../types/api';

/** Sentence-case wording for the post type, as on the review screen. */
export const POST_TYPE_LABEL: Readonly<Record<PostType, string>> = {
  single_image: 'Single image',
  carousel: 'Carousel',
  text_only: 'Text only',
};

/** A short mark for a post with no picture to show, by shape. */
export const POST_TYPE_GLYPH: Readonly<Record<PostType, string>> = {
  single_image: 'Image',
  carousel: 'Deck',
  text_only: 'Text',
};

const ORDINAL_SUFFIX: Readonly<Record<string, string>> = {
  one: 'st',
  two: 'nd',
  few: 'rd',
  other: 'th',
};
const ordinalRules = new Intl.PluralRules('en', { type: 'ordinal' });

/** "2nd try": how a counted attempt reads to the user. */
export function tryLabel(attempt: number): string {
  return `${attempt}${ORDINAL_SUFFIX[ordinalRules.select(attempt)] ?? 'th'} try`;
}

/**
 * The words a post is recognised by: what was asked for, else what was written,
 * else the honest fallback. `caption_preview` is optional on the wire (an older
 * deploy sends none), so its absence reads exactly like null.
 */
export function postTitle(
  request: Pick<GenerationRequestSummaryRead, 'topic' | 'caption_preview'>,
): string {
  return request.topic ?? request.caption_preview ?? 'From brand profile';
}
